<template>
  <button class="base-help-button">
    <div class="base-help-button__icon">
      <BaseIcon :name="icon"/>
    </div>
    <span class="base-help-button__text">
      {{ text }}
      <a v-if="linkAction" href="#" @click.prevent="linkAction()">{{ linkLabel }}</a>
      <a v-else :href="linkUrl" target="_blank" rel="noopener noreferrer">{{ linkLabel }}</a>
    </span>
  </button>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        default: 'help'
      },
      text: String,
      linkLabel: String,
      linkUrl: String,
      linkAction: Function
    },
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';
  @import './src/assets/styles/grid.scss';

  .base-help-button {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid $color-border;
    border-radius: 35px;
    margin: 50px auto 0;
    cursor: auto;

    @include media(ltMobile) {
      justify-content: center;
      width: calc(100% + #{$container-gutter-mobile} * 2);
      border-right: none;
      border-left: none;
      border-radius: 0;
      margin-left: -$container-gutter-mobile;
    }

    &__icon {
      width: 40px;
      height: 40px;
      padding: 10px;
      background-color: $color-white;
      border-radius: 50%;
      margin-right: 8px;
      color: $color-puerto-rico;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &__text {
      font-size: 14.6px;
      line-height: 1.71;
    }

    a {
      color: $color-lochmara;

      &:focus {
        outline: 2px solid $color-purple;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseHelpButton.vue